<template>
	<div class="box">
		<div class="null-page" v-show="yes"></div>
		
		<div class="member-info" v-loading="loading">
			<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
				<el-tab-pane label="基本信息" name="first">
					<el-form ref="infoRef" :model="memberInfo" :rules="infoRules" label-width="100px">
						<el-form-item label="账号" v-if="memberInfo.userName">
							<p>{{ memberInfo.userName }}</p>
						</el-form-item>
						<!--<el-form-item label="邮箱">
							<p v-if="memberInfo.email">{{ memberInfo.email }}</p>
							<p v-else class="toBind" @click="$router.push({ path: '/member/security' })">去绑定</p>
						</el-form-item>-->
						<el-form-item label="手机号">
							<p v-if="memberInfo.tell">{{ memberInfo.tell }}</p>
							<p v-else class="toBind" @click="$router.push({ path: '/member/security' })">去绑定</p>
						</el-form-item>
						<el-form-item label="昵称" prop="nickName"><el-input v-model="memberInfo.nickName"></el-input></el-form-item>
						<el-form-item label="授权公司名称" prop="comname"><el-input v-model="memberInfo.comname"></el-input></el-form-item>
						<el-form-item label="公司地址"><el-input v-model="memberInfo.addr"></el-input></el-form-item>
						<el-form-item label="营业执照编码" prop="license_no"><el-input v-model="memberInfo.license_no"></el-input></el-form-item>
						<el-form-item label="开户行名称" prop="codename"><el-input v-model="memberInfo.codename"></el-input></el-form-item>
						<el-form-item label="开户行帐户" prop="bank_code"><el-input v-model="memberInfo.bank_code"></el-input></el-form-item>
						<el-form-item label="开户行行号" prop="bank_num"><el-input v-model="memberInfo.bank_num"></el-input></el-form-item>
						<el-form-item label="纳税人识别号" prop="tax_num"><el-input v-model="memberInfo.tax_num"></el-input></el-form-item>
						<el-form-item label="公司营业执照"><el-upload
								ref="upload"
								:file-list="fileList"
								:action="udActionUrl"
								list-type="picture-card"
								:on-success="
									(file, fileList) => {
										return handleSuccess(file, fileList);
									}
								"
								:on-preview="handlePictureCardPreview"
								:on-remove="
									(file, fileList) => {
										return handleRemove(file, fileList);
									}
								"
								:on-exceed="handleExceed"
							>
								<i class="el-icon-plus"></i>
							</el-upload>
						</el-form-item>
						<el-dialog :visible.sync="dialogVisible"><img width="100%" :src="dialogImageUrl" alt="" /></el-dialog>						
					</el-form>
					<div class="btn"><el-button size="medium" type="primary" @click="saveInfo">保存</el-button></div>
				</el-tab-pane>
				<el-tab-pane label="头像照片" name="second">
					<div class="preview">
						<div class="title">头像预览</div>
						<div class="content">
							完善个人信息资料，上传头像图片有助于您结识更多的朋友。
							<br />
							头像最佳默认尺寸为120x120像素。
						</div>
					</div>
					<el-upload :action="uploadActionUrl" :show-file-list="false" :on-success="handleAvatarSuccess" class="upload">
						<div class="img-wrap"><img :src="$img(memberInfo.userHeadImg)" @error="memberInfo.userHeadImg = defaultHeadImage" /></div>
					</el-upload>
					<div class="btn"><el-button size="medium" type="primary" @click="uploadHeadImg">保存</el-button></div>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
import { info, nickName, headImg } from '@/api/member/info';
import Config from '@/utils/config';
import { mapGetters } from 'vuex';
import { email } from '@/api/member/security';
export default {
	name: 'info',
	components: {},
	data: () => {
		return {
			memberInfo: {
				userHeadImg: '',
				userName: '', //账号
				nickName: '', //昵称
				comname: '', //昵称
				email: '',
				tell: '',
				addr: '',
				license_no: '',
				codename: '',
				bank_code: '',
				bank_num: '',
				tax_num: '',
				license_images: '',
			},
			infoRules: {
				nickName: [{ required: true, message: '请输入昵称', trigger: 'blur' }, { max: 30, message: '最大长度为30个字符', trigger: 'blur' }]
			},
			activeName: 'first',
			loading: true,
			uploadActionUrl: Config.baseUrl + '/api/upload/headimg',
			imgUrl: '',
			imgList: [],
			udActionUrl: Config.baseUrl + '/api/upload/evaluateimg',
			dialogImageUrl: '',
			dialogVisible: false,
			yes: true,
			fileList: []
		};
	},
	created() {
		this.getInfo();
	},
	mounted() {
		let self = this;
		setTimeout(function() {
			self.yes = false
		}, 300)
	},
	methods: {
		handleSuccess(file, fileList) {
			console.log('AA',fileList);
			let arr = this.imgList;
			if(arr){
				arr = arr.concat(file.data.pic_path);				
			}
			if(this.memberInfo.license_images){
				this.memberInfo.license_images  = this.memberInfo.license_images +','+arr.toString();				
			}else{
				this.memberInfo.license_images  = arr.toString();
			}
		},
		handleRemove(file, fileList) {
			let imgesarr = this.memberInfo.license_images.split(',');
			console.log('BB',imgesarr);
			let i = util.inArray(file.response.data.pic_path, imgesarr);
			imgesarr.splice(i, 1);
			console.log('删除',imgesarr);
			this.memberInfo.license_images= imgesarr.join(',');
		},
		handleExceed(file, fileList) {
			// 图片数量大于6
			this.$message.warning('上传图片最大数量为6张');
		},
		handlePictureCardPreview(file) {
			// 点开大图
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		getInfo() {
			info()
				.then(res => {
					if (res.code == 0) {
						this.memberInfo.userHeadImg = res.data.headimg;
						this.memberInfo.userName = res.data.username;
						this.memberInfo.nickName = res.data.nickname;
						this.memberInfo.comname = res.data.comname;
						this.memberInfo.email = res.data.email;
						this.memberInfo.tell = res.data.mobile;
						
						this.memberInfo.addr = res.data.addr;
						this.memberInfo.license_no = res.data.license_no;
						this.memberInfo.codename = res.data.codename;
						this.memberInfo.bank_code = res.data.bank_code;
						this.memberInfo.bank_num = res.data.bank_num;
						this.memberInfo.tax_num = res.data.tax_num;
						this.memberInfo.license_images = res.data.license_images;
						var arrimgs=res.data.license_images.split(',');
						var arrlist=[];
						if(arrimgs){	
							Object.keys(arrimgs).forEach(key => {
								if(arrimgs[key]){									
									var array=[];
									array['name']=key+1;
									array['url']=arrimgs[key];
									array['response']=[];
									array['response']['data']=[];
									array['response']['data']['pic_path']=arrimgs[key];
									arrlist.push(array);
								}
							})
							this.fileList=arrlist;	
						}
					}
					this.loading = false;
				})
				.catch(err => {
					this.loading = false;
					this.$message.error(err.message);
				});
		},
		handleClick(tab, event) {},
		saveInfo() {
			this.$refs.infoRef.validate(valid => {
				if (valid) {
					nickName({ 
						nickname: this.memberInfo.nickName,
						comname: this.memberInfo.comname,
						addr: this.memberInfo.addr,
						license_no: this.memberInfo.license_no,
						codename: this.memberInfo.codename,
						bank_code: this.memberInfo.bank_code,
						bank_num: this.memberInfo.bank_num,
						tax_num: this.memberInfo.tax_num,
						license_images: this.memberInfo.license_images
					})
						.then(res => {
							if (res.code == 0) {
								this.$message({ message: '修改昵称成功', type: 'success' });
								this.getInfo;
								this.$store.dispatch('member/member_detail', { refresh: 1 });
							}
						})
						.catch(err => {
							this.$message.error(err.message);
						});
				} else {
					return false;
				}
			});
		},
		handleAvatarSuccess(res, file) {
			this.imgUrl = res.data.pic_path;
			this.memberInfo.userHeadImg = URL.createObjectURL(file.raw);
		},
		uploadHeadImg() {
			headImg({ headimg: this.imgUrl })
				.then(res => {
					if (res.code == 0) {
						this.$message({ message: '头像修改成功', type: 'success' });
						this.$store.dispatch('member/member_detail', { refresh: 1 });
					}
				})
				.catch(err => {
					this.$message.error(err.message);
				});
		}
	},
	computed: {
		...mapGetters(['defaultHeadImage'])
	}
};
</script>
<style>
.member-info .el-upload {
	display: flex;
	justify-content: center;
	margin-bottom: 20px;
}
</style>
<style lang="scss" scoped>
.box {
	width: 100%;
	position: relative;
}

.null-page {
	width: 100%;
	height: 730px;
	background-color: #FFFFFF;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 9;
}


.ishide .el-upload--picture-card {
	display: none;
}

.member-info {
	background: #ffffff;
	padding: 20px;
	.el-tab-pane {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-content: center;
		.preview {
			display: flex;
			justify-content: center;
			margin-bottom: 20px;
			.title {
				margin-right: 20px;
				line-height: 3;
			}
			.content {
				color: $base-color;
				line-height: 1.5;
			}
		}
		.upload {
			display: flex;
			justify-content: center;
		}
		.el-upload {
			width: 120px;
		}
		.img-wrap {
			width: 120px;
			height: 120px;
			display: block;
			line-height: 120px;
			overflow: hidden;
			border: 1px solid #f1f1f1;
			cursor: pointer;
			img {
				display: inline-block;
			}
		}
		.el-form {
			margin-top: 20px;
			width: 500px;
			margin-left: 200px;
			.toBind {
				cursor: pointer;
				&:hover {
					color: $base-color;
				}
			}
		}
		.btn {
			text-align: center;
		}
	}
}
</style>


<style lang="scss">
.el-upload-list {float:left;}
.el-icon-plus{ line-height: 70px;}
.member-info {
	.el-upload--picture-card,
	.el-upload-list--picture-card .el-upload-list__item {
		width: 70px;
		height: 70px;
		line-height: 80px;
		position: relative;
	}
	.el-upload-list--picture-card .el-upload-list__item-thumbnail {
		width: 100%;
		height: auto;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
	}
	.el-upload-list__item.is-success .el-upload-list__item-status-label {
		display: none;
	}
	.ishide .el-upload--picture-card {
		display: none;
	}
	.el-dialog {
		.el-dialog__body {
			text-align: center;
		}
	}
}
</style>
